import { useSelector } from "react-redux";

import { ComponentLuckyDraw } from "@components";
import { selectAuth } from "@redux";


export const PageLuckyDraw = () => {
    //redux states
    const { userInfo } = useSelector(selectAuth);

    //variable
    const memberTier = userInfo?.memberTier;

    return (
        <ComponentLuckyDraw
            memberTier={memberTier} avatar={""} fullName={""} />
    );
};
